import useFeatureFlag from 'app/hooks/useFeatureFlag';
import { FEATURE_FLAGS } from 'app/services/featureFlag.service';

function useFeatureFlagAnalytics() {
  const { value: showAmplitude } = useFeatureFlag(FEATURE_FLAGS.SHOW_AMPLITUDE);

  return {
    showAmplitude: showAmplitude === undefined ? true : showAmplitude,
  };
}

export default useFeatureFlagAnalytics;
